document.addEventListener('DOMContentLoaded', () => {
  class ProductGridHandler {
    constructor() {
      this.productGrid = document.querySelector('#product-grid')
        ? document.querySelector('#product-grid')
        : document.querySelector('#blog-grid');
      this.progressBar = document.querySelector('.progress-bar-fill');
      this.loadMoreButton = document.querySelector('.load-more_btn');
      this.loadPreviousButton = document.querySelector('.load-previous_btn');
      this.totalResults = parseInt(document.querySelector('.total-results').textContent);
      this.productGrid.dataset.resultsToShow || this.productGrid.getAttribute('data-results-to-show');
      this.nextUrl = this.productGrid.dataset.nextUrl || this.productGrid.getAttribute('data-next-url');
      this.previousUrl = this.productGrid.dataset.previousUrl || this.productGrid.getAttribute('data-previous-url');
      this.itemsShown = this.productGrid.querySelectorAll('li:not(.promotional-block-main)').length;
      if (document.querySelector('#blog-grid'))
        this.itemsShown = this.productGrid.querySelectorAll('div.article-card-wrapper').length;

      const urlParams = new URLSearchParams(window.location.search);
      this.page = parseInt(urlParams.get('page'));

      this.registerEventListeners();
      this.initialState();
    }

    registerEventListeners() {
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadMoreItems();
        });
      }
      if (this.loadPreviousButton) {
        this.loadPreviousButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadPreviousItems();
        });
      }
    }

    initialState() {
      this.updateProgressBar();
      this.updateVisibility();
      this.addGridClickEventListener();
    }

    updateVisibility() {
      this.loadMoreButton.style.display = this.nextUrl ? 'inline-flex' : 'none';
      this.loadPreviousButton.style.display = this.previousUrl ? 'inline-flex' : 'none';
      document.querySelector('.load-more--next .loading__spinner').classList.add('hidden');
      document.querySelector('.load-more--previous .loading__spinner').classList.add('hidden');
    }

    updateProgressBar() {
      const progress = (this.itemsShown / this.totalResults) * 100;
      document.querySelector('.items-shown').textContent = this.itemsShown;
      this.progressBar.style.width = `${progress}%`;
    }

    async handleRequest(url, onSuccess, onStart, onError, scrollGridIntoView = false) {
      if (!url) return;
      onStart();
      try {
        const response = await fetch(url);
        const data = await response.text();
        onSuccess(data);
        window.history.pushState({}, '', url);
        if (scrollGridIntoView) {
          this.productGrid.scrollIntoView({ behavior: 'smooth' });
        }
      } catch (error) {
        console.error('Error:', error);
        onError(error.statusText);
      }
    }

    loadMoreItems() {
      if (this.nextUrl === 'null') return;
      this.handleRequest(
        this.nextUrl,
        (responseText) => {
          this.handleResponse(responseText, 'beforeend');
          this.nextUrl = this.productGrid.getAttribute('data-next-url');
          this.previousUrl = this.productGrid.getAttribute('data-previous-url');
          this.updateLoadHref(this.loadMoreButton, this.nextUrl);
          this.updateVisibility();
          this.updateProgressBar();
        },
        () => {
          this.loadMoreButton.style.display = 'none';
          document.querySelector('.load-more--next .loading__spinner').classList.remove('hidden');
        },
        (error) => console.error('Error:', error),
        false
      );
    }

    loadPreviousItems() {
      this.handleRequest(
        this.previousUrl,
        (responseText) => {
          this.handleResponse(responseText, 'afterbegin', true);
          this.nextUrl = this.productGrid.getAttribute('data-next-url');
          this.previousUrl = this.productGrid.getAttribute('data-previous-url');
          this.updateLoadHref(this.loadPreviousButton, this.previousUrl);
          this.updateLoadHref(this.loadMoreButton, this.nextUrl);
          this.updateVisibility();
          this.updateProgressBar();
        },
        () => {
          this.loadPreviousButton.style.display = 'none';
          document.querySelector('.load-more--previous .loading__spinner').classList.remove('hidden');
        },
        (error) => console.error('Error:', error),
        false
      );
    }

    handleResponse(responseText, position, page = false) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = responseText;
      const newResults = tempDiv.querySelector('#product-grid')
        ? tempDiv.querySelector('#product-grid')
        : tempDiv.querySelector('#blog-grid');

      if (newResults) {
        this.productGrid.insertAdjacentHTML(position, newResults.innerHTML);
        this.productGrid.querySelectorAll('li').forEach((item) => (item.style.display = 'block'));
        if (position === 'beforeend') {
          this.productGrid.setAttribute('data-next-url', newResults.getAttribute('data-next-url'));
        } else {
          this.productGrid.setAttribute('data-previous-url', newResults.getAttribute('data-previous-url'));
        }
        this.itemsShown = this.productGrid.querySelectorAll('li:not(.promotional-block-main)').length;
        if (document.querySelector('#blog-grid'))
          this.itemsShown = this.productGrid.querySelectorAll('div.article-card-wrapper').length;
        this.updateProgressBar(this.itemsShown, this.totalResults);
        this.addGridClickEventListener();
      }
    }

    addGridClickEventListener() {
      document.querySelectorAll('.grid__item')?.forEach((grid) => {
        grid.addEventListener(
          'click',
          function (event) {
            event.stopPropagation();
            const item = event.target.closest('a');
            if (item && item.hasAttribute('data-product-id')) {
              localStorage.setItem('selectedProductId', item.getAttribute('data-product-id'));
            } else {
              console.warn('This item does not have a "data-product-id" attribute.');
            }
          },
          { once: true }
        );
      });
    }

    updateLoadHref(button, url) {
      button.setAttribute('href', url.toString());
    }


  }

  new ProductGridHandler();
});
